import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/scheduleSiteWorkActions'
import * as api from '../../api/job/scheduleSiteWork'

function* getScheduleSiteWorkDates(action) {
  try {
    const payload = yield call(api.getScheduleSiteWorkDates, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_SITE_WORK_DATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_SITE_WORK_DATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetScheduleSiteWorkDates() {
  yield takeLatest(constants.GET_SCHEDULE_SITE_WORK_DATES.ACTION, getScheduleSiteWorkDates)
}

function* sagaAddScheduleSiteWorkDate(action) {
  try {
    const payload = {
      job_id: action.jobId,
      updated_by_id: action.userId,
      created_by_id: action.userId,
      user_id: action.userId,
      schedule_id: action.scheduleId
    }

    yield call(api.addScheduleSiteWorkDates, payload)
    yield put({ type: constants.ADD_SCHEDULE_SITE_WORK_DATE.SUCCESS, payload })
    yield call(getScheduleSiteWorkDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_SCHEDULE_SITE_WORK_DATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddScheduleSiteWorkDate() {
  yield takeLatest(constants.ADD_SCHEDULE_SITE_WORK_DATE.ACTION, sagaAddScheduleSiteWorkDate)
}

function* sagaUpdateScheduleSiteWorkDates(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      content: action.content,
      updated_by_id: action.userId,
      type: action.scheduleType,
      due_date: action.content[action.scheduleType],
      assigned_to_id: 1,
      user_id: 1
    }

    yield call(api.updateScheduleSiteWorkDates, payload)
    yield put({ type: constants.SCHEDULE_SITE_WORK_UPDATE.SUCCESS, payload })
    yield call(getScheduleSiteWorkDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_SITE_WORK_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleSiteWork() {
  yield takeLatest(constants.SCHEDULE_SITE_WORK_UPDATE.ACTION, sagaUpdateScheduleSiteWorkDates)
}

function* sagaDeleteScheduleSiteWork(action) {
  try {
    const payload = {
      schedule_id: action.scheduleId
    }
    yield call(api.deleteScheduleSiteWork, payload)
    yield put({ type: constants.DELETE_SCHEDULE_SITE_WORK.SUCCESS, payload })
    yield call(getScheduleSiteWorkDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_SITE_WORK.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleSiteWork() {
  yield takeLatest(constants.DELETE_SCHEDULE_SITE_WORK.ACTION, sagaDeleteScheduleSiteWork)
}

function* sagaUpdateScheduleDrawingNotes(action) {
  try {
    const payload = {
      job_id: action.jobId,
      notes: action.notes,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateScheduleSiteWorkNotes, payload)
    yield put({ type: constants.SCHEDULE_SITE_WORK_UPDATE_NOTE.SUCCESS, payload })
    yield call(getScheduleSiteWorkDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_SITE_WORK_UPDATE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleSiteWorkNotes() {
  yield takeLatest(constants.SCHEDULE_SITE_WORK_UPDATE_NOTE.ACTION, sagaUpdateScheduleDrawingNotes)
}

export function* rootSaga() {
  yield all([
    fork(watchGetScheduleSiteWorkDates),
    fork(watchUpdateScheduleSiteWork),
    fork(watchUpdateScheduleSiteWorkNotes),
    fork(watchAddScheduleSiteWorkDate),
    fork(watchDeleteScheduleSiteWork)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/scheduleSiteWorkSaga.js